import type {Address, BasisType, Customer, DKK, Goal, Partner, RRDate, Service, Time} from "@raskrask-dk/raskrask-utils";
import {ChooseNoAvailable} from "../../action/generalActions/choosenotavailable.action";
import {Next, SetGoal, SetServiceType, SetDate, SetPartner, SetTime, ChoosePackage} from "./actions";

export type CalendarActions = Next | SetGoal | SetServiceType | SetDate | SetPartner | SetTime | ChoosePackage | ChooseNoAvailable;

export const calendarActions = [Next, SetGoal, SetServiceType, SetDate, SetPartner, SetTime, ChoosePackage, ChooseNoAvailable] as const;

export type calActions = (typeof calendarActions)[number];

export type CalendarStateDependencies = {
  address: Address;
  basisType: BasisType;
  customerType: Customer["type"];
  service?: Service;
  partner?: Partner;
  goal?: Goal;
};

export interface IGetCalendarData {
  address: Address;
  basisType: BasisType;
  customerType: Customer["type"];
  goal: Goal | undefined;
  serviceType: Service | undefined;
  partner: Partner | undefined;
  date: RRDate | undefined;
  time: Time | undefined;
  packageSaveMinAndPriceFrom: {saveMin: DKK; priceFrom: DKK} | undefined;
}
